








































import Vue from 'vue';
import Component from 'vue-class-component';

import { Action, Modules } from '@/store/store';
import { namespace } from 'vuex-class';

import type { SubBrand, Theme } from '@/store/modules/themes';
import { Model } from '@/store/modules/charging-data.interface';
import SubHeadline from '../sub-headline/sub-headline.vue';

const themeModule = namespace(Modules.themes);
const dataModule = namespace(Modules.chargingData);
const configModule = namespace(Modules.config);

@Component({
  name: 'eqweb-class-selection',
  components: { SubHeadline },
})
export default class ClassSelection extends Vue {
  @themeModule.Getter('propsTheme')
  private readonly theme!: Theme;

  @themeModule.Getter('subBrand')
  private readonly subBrand!: SubBrand;

  @dataModule.Getter('models')
  private readonly models!: Model[];

  @configModule.Getter('showModelSelectionDots')
  private readonly showModelSelectionDots!: boolean;

  @dataModule.Getter('selectedModel')
  private readonly selectedModel!: Model;

  @dataModule.Action('setSelectedModel')
  private readonly setSelectedModel!: Action<Model>;

  private get selectedModelName(): string {
    return this.selectedModel.className;
  }

  private get selectedModelSliderIndex(): number {
    return this.models.findIndex((model) => model.modelSeries === this.selectedModel.modelSeries) + 1 || 1;
  }

  private async setModel(event: CustomEvent) {
    const newIndex = event.detail;
    const newModelIndex = newIndex - 1;
    this.setSelectedModel(this.models[newModelIndex]);
  }
}
